import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface syncAssignmentsSchoology {
    message: string | null;
    isLoading: boolean;
    error: string | null;
}

const initialState: syncAssignmentsSchoology = {
    message: null,
    isLoading: false,
    error: null,
};

const syncAssignmentsSchoologySlice = createSlice({
    name: 'syncAssignmentsSchoology',
    initialState,
    reducers: {
        setSyncAssignment: (state: syncAssignmentsSchoology, action: PayloadAction<syncAssignmentsSchoology>) => {
            state.message = action.payload.message;
            state.isLoading = false;
            state.error = null;
        },
        setloading: (state: syncAssignmentsSchoology, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
            state.error = null;
        },
        seterror: (state: syncAssignmentsSchoology, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.isLoading = false;
        },
        resetSyncAssignment: () => {
            return initialState;
        },
    },
});

export const { setSyncAssignment, setloading, seterror, resetSyncAssignment } = syncAssignmentsSchoologySlice.actions;

export default syncAssignmentsSchoologySlice.reducer;